var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading == _vm.id)?_c('button',{class:_vm.btnClass + 'btn disabled',attrs:{"id":_vm.id}},[_c('Loading')],1):_c('button',{class:_vm.btnClass + 'btn',attrs:{"id":_vm.id},on:{"click":function($event){return _vm.action()}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }